import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entry", "label"]

  connect() {
    // Controller connected successfully
  }

  filter(event) {
    event.preventDefault()
    const taskId = event.currentTarget.dataset.taskId
    const taskName = event.currentTarget.textContent.trim()
    
    // Update the filter label
    this.labelTarget.textContent = taskId === 'all' ? 'Filter by Task' : taskName

    // Show/hide entries based on task
    this.entryTargets.forEach(entry => {
      const entryTaskId = entry.dataset.taskId
      const shouldShow = taskId === 'all' || entryTaskId === taskId
      
      if (shouldShow) {
        entry.style.display = ''
      } else {
        entry.style.display = 'none'
      }
    })
  }
} 